/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        buttonTile: {
            default: {
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
            hover: {
                backgroundColor: {
                    value: "#f3f3f3",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
                borderColor: {
                    value: "#dadada",
                    type: "color",
                },
            },
            active: {
                backgroundColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
                borderColor: {
                    value: "#282e37",
                    type: "color",
                },
                borderWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderStyle: {
                    value: "solid",
                    type: "strokeStyle",
                },
            },
            focus: {
                borderColor: {
                    value: "#282e37",
                    type: "color",
                },
                borderWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderStyle: {
                    value: "solid",
                    type: "strokeStyle",
                },
            },
            disabled: {
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
                color: {
                    value: "#a0a2a5",
                    type: "color",
                },
            },
            icon: {
                color: {
                    value: "#d3222a",
                    type: "color",
                },
                disabled: {
                    color: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
                muted: {
                    color: {
                        value: "#6f7377",
                        type: "color",
                    },
                },
            },
            sizes: {
                small: {
                    height: {
                        value: "48px",
                        type: "dimension",
                    },
                    borderRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "16px",
                        type: "dimension",
                    },
                    gap: {
                        value: "16px",
                        type: "dimension",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.5rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                },
                large: {
                    height: {
                        value: "140px",
                        type: "dimension",
                    },
                    width: {
                        value: "189px",
                        type: "dimension",
                    },
                    minWidth: {
                        value: "189px",
                        type: "dimension",
                    },
                    borderRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "40px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "8px",
                        type: "dimension",
                    },
                    gap: {
                        value: "4px",
                        type: "dimension",
                    },
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                    label: {
                        height: {
                            value: "40px",
                            type: "dimension",
                        },
                    },
                },
            },
            statusIndicator: {
                new: {
                    backgroundColor: {
                        value: "#ff8981",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                beta: {
                    backgroundColor: {
                        value: "#fff2aa",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                sunset: {
                    backgroundColor: {
                        value: "#d7f6ff",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                demo: {
                    backgroundColor: {
                        value: "#d2ff9c",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
